__turbopack_context__.v({
  "banner-text-center": "hero-section-module-scss-module__zr929q__banner-text-center",
  "coming-soon-text": "hero-section-module-scss-module__zr929q__coming-soon-text",
  "coming-soon-text-container": "hero-section-module-scss-module__zr929q__coming-soon-text-container",
  "container": "hero-section-module-scss-module__zr929q__container",
  "content-section": "hero-section-module-scss-module__zr929q__content-section",
  "cta-banner": "hero-section-module-scss-module__zr929q__cta-banner",
  "cta-banner-link": "hero-section-module-scss-module__zr929q__cta-banner-link",
  "description": "hero-section-module-scss-module__zr929q__description",
  "logo": "hero-section-module-scss-module__zr929q__logo",
  "video-section": "hero-section-module-scss-module__zr929q__video-section",
});
